import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Axios from "axios";
import url from "../../../services/url";
import { If, Else } from "react-condition";
import PersonalDetails from "../../Candidate/ApplicationView.PersonalDetails";
import slugify from "slugify";
import uploadSizes from "../../../services/uploadSizes";
import $ from "jquery";
import cx from "classnames";
import swal from "sweetalert";
import { withRouter } from "react-router";
import axios from "../../../services/axios";
import ReactLoading from "react-loading";
import BASE from "../../../config";
import { useHistory } from "react-router-dom";
import GetFormComponent from "../../Candidate/GetFormComponent";
import useAxios from "../../../hooks/useAxios";
import { message } from "antd";

function base64ToFile(
  base64String,
  filename,
  mimeType = "application/octet-stream",
) {
  if (!base64String) return null;

  const base64Data = base64String.replace(/^data:[^;]+;base64,/, "");

  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  return new File([byteArray], filename, { type: mimeType });
}

const AGENT_APPLICATION_ID = "61d41ac7cc03506243d626f9";

function UpdateCandidateForm() {
  const { formId: id, candidateId: ids, formType } = useParams();
  const history = useHistory();
  const candidateId = ids;
  const { hash } = useLocation();
  localStorage.setItem("form_id", id);
  const [courseType, setCourseType] = useState("");
  const [load, setLoad] = useState(false);

  const [form, setForm] = useState({
    name: "Loading form...",
    elements: [],
    candidatePhoto: false,
    candidateVideo: false,
    resume: false,
    trf: {
      title: "Loading form...",
      overview: "Please wait a moment for this to load.",
    },
  });

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // add validation just below the input box
  const [formError, setFormError] = useState({});
  const [candidateInformation, setCandidateInformation] = useState();
  const [interviews, setInterviews] = useState([]);
  const [errorInputs, setErrorInputs] = useState([]);
  const [departments, setDepartments] = useState([]);

  const api = useAxios();

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  const getCandidateInfo = async (formType) => {
    try {
      let url = ``;

      if (formType === "long-form") {
        url = `/candidates/${candidateId}`;
      } else {
        url = `/candidates/BulkUpload/${candidateId}`;
      }

      const res = await api.get(url, {
        tokenType: "candidate",
      });
      const { data } = res;
      if (data?.voiceBotData && data?.voiceBotData?.qualification_extraction) {
        if (
          (data?.voiceBotData?.qualification_extraction || "").toLowerCase() !==
          "na"
        ) {
          const { data: d } = await api.post(`/candidate/getCourseType`, {
            Qualification: data?.voiceBotData?.qualification_extraction,
          });
          setCourseType(d?.degree || "");
        }
      }
      setCandidateInformation(data);
      return data;
    } catch (err) {
      console.error(err);
    }
  };

  const getCandidateInterview = async () => {
    try {
      const res = await api.put(
        `/interviews`,
        {
          candidate: candidateId,
        },
        {
          tokenType: "candidate",
        },
      );
      const { data } = res;
      setInterviews(data);
    } catch (err) {
      console.error(err);
    }
  };

  const getFormTemplate = async () => {
    try {
      const res = await api.get(`/formtemplate/${id}`, {
        tokenType: "candidate",
      });
      const results = filterChildElements(res.data.elements);
      res.data.elements = [...PersonalDetails.elements, ...results];
      setForm(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getDepartment = async () => {
    try {
      const { data } = await api.get(`/trfdepartment`, {
        tokenType: "candidate",
      });

      const { trfDepartment } = data;
      setDepartments(trfDepartment.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!candidateId || !id) return;

    const init = async () => {
      try {
        const data = await getCandidateInfo("long-form");
        if (data?.responses?.length === 0) {
          await getCandidateInfo("short-form");
        }
        await Promise.all([
          getCandidateInterview(),
          getFormTemplate(),
          getDepartment(),
        ]);
        setIsLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    init();
  }, [candidateId, id, formType]);

  //Remove child from main array -Lovejot(06-DEC-2022)
  const filterChildElements = (elementsArray) => {
    let arrr = [];
    for (let item of elementsArray) {
      if (item === null) {
        continue;
      } else {
        if (item?.type === "select" || item?.type === "radio") {
          for (let i = 0; i < item?.parent?.length; i++) {
            arrr.push(item?.parent[i]?.child?.id);
          }
        }
      }
    }
    const results = elementsArray.filter(
      (ele) => ele != null && !arrr.some((index) => index === ele.id),
    );
    return results;
  };

  useEffect(() => {
    function buildAccordions() {
      $(".form-builder-element:not(.heading)").addClass("hidden");
      $(".form-builder-element.heading .btn").on("click", function () {
        $(".form-builder-element:not(.heading)").addClass("hidden");
        let currentElements = $(this)
          .parent()
          .nextUntil(".form-builder-element.heading");
        currentElements.toggleClass("hidden");
      });
      setTimeout(openOnlyFirstAccordion, 100);
      setTimeout(addDividersBeforeHeadings, 150);
    }
    if (form.name !== "Loading form...") {
      //setTimeout(buildAccordions, 100);
    }
  }, [form]);

  // Events
  function openOnlyFirstAccordion() {
    $(".form-builder-element.heading:nth-child(1) .btn").click();
  }

  function addDividersBeforeHeadings() {
    let headings = $("#candidateForm .form-builder-element.heading").slice(1);
    $(
      `<div className="form-builder-element divider"><hr /></div>`,
    ).insertBefore(headings);
  }

  async function onClickFormSubmit(event) {
    event.preventDefault();
    setError("");

    let error = [];
    setErrorInputs(error);

    let formData = [];
    let currentError = "";
    //var currentError = ""
    document.querySelectorAll(".form-view").forEach((input) => {
      let element = JSON.parse(input.getAttribute("data"));
      let data = {};
      let supplement = true;

      if (element !== null) {
        // Input Generation
        if (element.type === "texttable") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let value = {};
            document
              .querySelectorAll(
                "[name='" + slugify(element.properties.label) + "']",
              )
              .forEach((textfield) => {
                let row = textfield.getAttribute("row");
                let column = textfield.getAttribute("column");
                if (value[row] === null || value[row] === undefined) {
                  value[row] = {};
                  value[row][column] = textfield.value;
                } else {
                  value[row][column] = textfield.value;
                }
              });
            data = {
              label: input.getAttribute("label"),
              value: JSON.stringify(value),
              element,
            };
          }
        } else if (element.type === "checkbox") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let value = [];
            document
              .querySelectorAll(
                "[name='" + slugify(element.properties.label) + "']:checked",
              )
              .forEach((checkbox) => {
                if (checkbox.checked) {
                  value.push(checkbox.getAttribute("value"));
                }
              });
            data = {
              label: input.getAttribute("label"),
              value,
              element,
            };
            // if (data.value.length === 0) {
            //   testError.location = "Preferred Location should be required";
            // }
          }
        } else if (element.type === "radio") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let radio = document.querySelector(
              "[name='" + slugify(element.properties.label) + "']:checked",
            );
            let value = null;
            if (radio !== null) {
              value = radio.value;
            }
            data = {
              label: input.getAttribute("label"),
              value,
              element,
            };
          }
        } else if (element.type === "multiSelect") {
          data = {
            label: input.getAttribute("label"),
            value: element.properties.value,
            element,
          };
        } else if (element.type === "datetime") {
          data = {
            label: input.getAttribute("label"),
            value: element.properties.value,
            element,
          };
        } else if (element.type === "capturephoto") {
          const elementWithoutValue = JSON.parse(JSON.stringify(element));
          delete elementWithoutValue.value;
          const file = base64ToFile(
            element?.value?.src || "",
            element?.value?.name,
            "image/png",
          );
          data = {
            label: element?.properties?.label,
            value: element?.value?.name,
            file: file,
            element: elementWithoutValue,
          };
        } else if (
          element.type === "file" &&
          document.getElementById(element.id).files[0] === undefined
        ) {
          data = {
            label: input.getAttribute("label"),
            value: element.properties.value,
            element,
          };
        } else if (element.type === "statecity") {
          data = {
            label: "statecity",
            valueOfField: [
              {
                label: "Select State",
                value: element?.value?.state || "",
                element,
              },
              {
                label: "Select City",
                value: element?.value?.city || "",
                element,
              },
            ],
            element,
          };
        } else if (element.type === "departmentdesignation") {
          const { value, ...rest } = element;
          data = {
            label: "departmentdesignation",
            valueOfField: [
              {
                label: "Select Department",
                value: element?.value?.departmentText || "",
                element: rest,
                _id: element?.value?.department || "",
              },
              {
                label: "Select Designation",
                value: element?.value?.designationText || "",
                element: rest,
                _id: element?.value?.designation || "",
              },
            ],
            element: rest,
          };
        } else {
          if (input instanceof HTMLDivElement) {
            data = {
              label: input.getAttribute("label"),
              value: input.getAttribute("value"),
              element,
            };
          } else {
            data = {
              label: input.getAttribute("label"),
              value: input.value,
              element,
            };
          }
        }

        // Input Validation
        if (supplement) {
          // Validation for select type field

          if (element?.type === "capturephoto") {
            if (data.element.properties.required === true) {
              if (!data.value) {
                currentError = `${data.element.properties.label} is required field.`;
                error.push({
                  label: data.element.properties.label,
                  value: `${data.element.properties.label} is required field.`,
                });
              }
            }
          }

          if (element.type === "statecity") {
            let checkCity = false;
            for (let i = 0; i < data?.valueOfField?.length; i++) {
              if (data?.valueOfField[i]?.element.properties.required === true) {
                if (data?.valueOfField[i].value === "") {
                  currentError = `State and City is required field.`;
                  error.push({
                    label: data?.valueOfField[i].label,
                    value: `State and City is required field.`,
                  });
                }
              } else {
                if (
                  data?.valueOfField[i].label.toLowerCase().trim() ===
                  "select state"
                ) {
                  if (data?.valueOfField[i].value !== "") {
                    checkCity = true;
                  }
                }
                if (checkCity) {
                  if (
                    data?.valueOfField[i].label.toLowerCase().trim() ===
                    "select city"
                  ) {
                    if (data?.valueOfField[i].value === "") {
                      currentError = `City is required field.`;
                      error.push({
                        label: data?.valueOfField[i].label,
                        value: `City is required field.`,
                      });
                    }
                  }
                }
              }
            }
          }

          if (element.type === "departmentdesignation") {
            let checkDesignation = false;
            for (let i = 0; i < data?.valueOfField?.length; i++) {
              if (data?.valueOfField[i]?.element.properties.required === true) {
                if (data?.valueOfField[i].value === "") {
                  currentError = `Department and Designation is required field.`;
                  error.push({
                    label: data?.valueOfField[i].label,
                    value: `Department and Designation is required field.`,
                  });
                }
              } else {
                if (
                  data?.valueOfField[i].label.toLowerCase().trim() ===
                  "select department"
                ) {
                  if (data?.valueOfField[i].value !== "") {
                    checkDesignation = true;
                  }
                }
                if (checkDesignation) {
                  if (
                    data?.valueOfField[i].label.toLowerCase().trim() ===
                    "select designation"
                  ) {
                    if (data?.valueOfField[i].value === "") {
                      currentError = `Designation is required field.`;
                      error.push({
                        label: data?.valueOfField[i].label,
                        value: `Designation is required field.`,
                      });
                    }
                  }
                }
              }
            }
          }

          if (element.properties !== null) {
            if (typeof data.value === "string") {
              let alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
              if (data.element.isAlpha === true && data.value.length !== 0) {
                if (!data.value.trim().match(alphabets)) {
                  currentError = `Only alphabets are allowed in ${data.label}`;
                  error.push({
                    label: data.label,
                    value: `Only alphabets are allowed in ${data.label}`,
                  });
                }
              }
              //Dynamic validations for Numbers -Lovejot(12-DEC-2022)
              let isnum = /^\d+$/;
              if (data.element.isNumber === true && data.value.length !== 0) {
                if (!isnum.test(data.value)) {
                  currentError = `Only Numbers are allowed in ${data.label}`;
                  error.push({
                    label: data.label,
                    value: `Only Numbers are allowed in ${data.label}`,
                  });
                }
              }

              //Dynamic Length validations for Numbers -Lovejot(12-DEC-2022)
              if (
                data.element.type === "text" ||
                data.element.type === "textarea" ||
                data.element.type === "number"
              ) {
                if (data.value.length !== 0) {
                  if (
                    data.element.properties.minLengthValidation !== undefined &&
                    data.element.properties.maxLengthValidation !== undefined
                  ) {
                    if (
                      data.value.trim().length >=
                        parseInt(data.element.properties.minLengthValidation) &&
                      data.value.trim().length <=
                        parseInt(data.element.properties.maxLengthValidation)
                    ) {
                      console.log("val error");
                    } else {
                      currentError = `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`;
                      error.push({
                        label: data.label,
                        value: `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`,
                      });
                    }
                  }
                }
              }
              var emailPattern = new RegExp(
                /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
              );
              // email validation
              if (data.label.trim() === "Email" && data.value.trim() === "") {
                currentError =
                  "'" + element.properties.label + "' is a required question.";
                error.push({
                  label: element.properties.label,
                  value: element.properties.label + " is a required question.",
                });
              } else if (
                data.label === "Email" &&
                !emailPattern.test(data.value)
              ) {
                currentError =
                  "Invalid email id format, Please fill correct email id";
                error.push({
                  label: element.properties.label,
                  value:
                    "Invalid email id format, Please fill correct email id",
                });
              }

              if (data.label === "Date of Birth") {
                var date = data.value.split("-");

                // Date of Age should be between 18-40 years

                var daterange = data.value;

                var today = new Date();
                var birthDate = new Date(daterange);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (
                  m < 0 ||
                  (m === 0 && today.getDate() < birthDate.getDate())
                ) {
                  age--;
                }
                if (age <= 17) {
                  currentError = "Age should not smaller than 18 year";
                  error.push({
                    label: element.properties.label,
                    value: "Age should not smaller than 18 year",
                  });
                } else if (age > 55) {
                  currentError = "Age should not greater than 55 year";
                  error.push({
                    label: element.properties.label,
                    value: "Age should not greater than 55 year",
                  });
                }
              }
              if (data.label === "Date of Birth" && data.value.trim() === "") {
                currentError =
                  "'" + element.properties.label + "' is a required field.";
                error.push({
                  label: element.properties.label,
                  value:
                    "'" + element.properties.label + "' is a required field.",
                });
              } else if (data.label === "Date of Birth") {
                if (date[0] < 1000 || date[0].length > 4) {
                  currentError = "Please enter valid date of birth";
                  error.push({
                    label: element.properties.label,
                    value: "Please enter valid date of birth",
                  });
                }
              }
            }
          }

          if (element.properties !== null) {
            // Validate Required Inputs
            if (element.properties.required !== null) {
              if (element.properties.required === true) {
                // Validate Stringed Inputs
                if (typeof data.value === "string") {
                  //Regular expression for validation
                  if (data.label === "Date of Birth") {
                    var date = data.value.split("-");

                    // Date of Age should be between 18-40 years

                    var daterange = data.value;

                    var today = new Date();
                    var birthDate = new Date(daterange);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (
                      m < 0 ||
                      (m === 0 && today.getDate() < birthDate.getDate())
                    ) {
                      age--;
                    }
                    if (age <= 17) {
                      currentError = "Age should not smaller than 18 year";
                      error.push({
                        label: element.properties.label,
                        value: "Age should not smaller than 18 year",
                      });
                    } else if (age > 55) {
                      currentError = "Age should not greater than 55 year";
                      error.push({
                        label: element.properties.label,
                        value: "Age should not greater than 55 year",
                      });
                    }
                  }
                  var nameRegex = new RegExp(/[^A-Z -]/gi);
                  var languagePattern = new RegExp(/[^A-Z -,]/gi);
                  var pattern = new RegExp(/^[0-9\b]+$/);
                  var emailPattern = new RegExp(
                    /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                  );
                  // regex for email:-  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

                  // test error here
                  if (data.value.trim() === "") {
                    if (data.label === "Name" && data.value.trim() === "") {
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label + " is a required question.",
                      });
                    }
                  }

                  //Phone Number Validation
                  if (
                    data.label === "Phone Number" &&
                    data.value.length !== 10
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid mobile format. Please enter only 10-digit mobile number.",
                    });
                  } else if (
                    data.label === "Phone Number" &&
                    !pattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Please enter only 10-digit mobile number.",
                    });
                  }

                  //Dynamic validations for alphabets -Lovejot(12-DEC-2022)
                  let alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
                  if (
                    data.element.isAlpha === true &&
                    data.value.length !== 0
                  ) {
                    if (!data.value.trim().match(alphabets)) {
                      currentError = `Only alphabets are allowed in ${data.label}`;
                      error.push({
                        label: element.properties.label,
                        value:
                          "Only alphabets are allowed in " +
                          element.properties.label,
                      });
                    }
                  }

                  //Dynamic validations for Numbers -Lovejot(12-DEC-2022)
                  let isnum = /^\d+$/;
                  if (
                    data.element.isNumber === true &&
                    data.value.length !== 0
                  ) {
                    if (!isnum.test(data.value)) {
                      currentError = `Only Numbers are allowed in ${data.label}`;
                      error.push({
                        label: element.properties.label,
                        value:
                          "Only Numbers are allowed in " +
                          element.properties.label,
                      });
                    }
                  }

                  if (
                    data.element.type === "text" ||
                    data.element.type === "textarea" ||
                    data.element.type === "number"
                  ) {
                    if (
                      data.element.properties.minLengthValidation !==
                        undefined &&
                      data.element.properties.maxLengthValidation !== undefined
                    ) {
                      if (
                        data.value.trim().length >=
                          parseInt(
                            data.element.properties.minLengthValidation,
                          ) &&
                        data.value.trim().length <=
                          parseInt(data.element.properties.maxLengthValidation)
                      ) {
                        console.log("val error");
                      } else {
                        currentError = `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`;
                        error.push({
                          label: data.label,
                          value: `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.minLengthValidation} are allowed in ${data.label}`,
                        });
                      }
                    }
                  }

                  //Aadhar Number Validation
                  if (
                    data.label === "Aadhar Number" &&
                    data.value.length !== 12
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid Aadhar format. Please enter only 12-digit aadhar number.",
                    });
                  } else if (
                    data.label === "Aadhar Number" &&
                    !pattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Please enter only 12-digit aadhar number.",
                    });
                  }

                  // Validate Address
                  if (data.label === "Address" && data.value.trim() === "") {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Address" &&
                    data.value.length >= 400
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Address should not more than 400 character",
                    });
                  }
                  // email validation
                  if (data.label === "Email" && data.value.trim() === "") {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Email" &&
                    !emailPattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid email id format, Please fill correct email id",
                    });
                  }

                  // Validate Date of birth
                  if (
                    data.label === "Date of Birth" &&
                    data.value.trim() === ""
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (data.label === "Date of Birth") {
                    if (date[0] < 1000 || date[0].length > 4) {
                      error.push({
                        label: element.properties.label,
                        value: "Please enter valid date of birth",
                      });
                    }
                  }

                  // Validation on languages
                  if (
                    data.label === "Indian Languages" &&
                    data.value.trim() === ""
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Indian Languages" &&
                    languagePattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Please enter correct languages, seperate by comma.",
                    });
                  }

                  // proper validation on the bottom of page

                  if (
                    (!data.value || data.value?.length === 0) &&
                    data.element.type !== "capturephoto" &&
                    data.element.type !== "file" &&
                    data.element.type !== "statecity" &&
                    data.element.type !== "departmentdesignation"
                  ) {
                    if (
                      data.value.trim() === "" ||
                      data.value.trim() === "null"
                    ) {
                      currentError =
                        "'" +
                        element.properties.label +
                        "' is a required question. Please fill it before submission.";
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label +
                          " is a required question. Please fill it before submission.",
                      });
                    } else if (
                      data.label === "Phone Number" &&
                      data.value.length !== 10
                    ) {
                      currentError =
                        "Invalid mobile format. Please enter only 10-digit mobile number.";
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid mobile format. Please enter only 10-digit mobile number.",
                      });
                    } else if (
                      data.label === "Phone Number" &&
                      !pattern.test(data.value)
                    ) {
                      currentError =
                        "Please enter only 10-digit mobile number.";
                      error.push({
                        label: element.properties.label,
                        value: "Please enter only 10-digit mobile number.",
                      });
                    } else if (
                      data.label === "Name" &&
                      data.value.length >= 40
                    ) {
                      currentError = "Name should not more than 40 character";
                      error.push({
                        label: element.properties.label,
                        value: "Name should not more than 40 character",
                      });
                    } else if (
                      data.label === "Address" &&
                      data.value.length >= 400
                    ) {
                      currentError =
                        "Address should not more than 400 character";
                      error.push({
                        label: element.properties.label,
                        value: "Address should not more than 400 character",
                      });
                    } else if (
                      data.label === "Email" &&
                      !emailPattern.test(data.value)
                    ) {
                      currentError = "Invalid email id format";
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid email format, Please fill correct email",
                      });
                    } else if (data.label === "Date of Birth") {
                      if (date[0] < 1000 || date[0].length > 4) {
                        currentError = "Please enter valid date of birth";
                        error.push({
                          label: element.properties.label,
                          value: "Please enter valid date of birth",
                        });
                      }
                    }
                  }
                }
                //   Validate Non-Stringed Inputs
                if (
                  (data.value === null || data.value?.length === 0) &&
                  data.element.type !== "capturephoto" &&
                  data.element.type !== "file" &&
                  data.element.type !== "statecity" &&
                  data.element.type !== "departmentdesignation"
                ) {
                  currentError =
                    "'" +
                    element.properties.label +
                    "' is a required question. Please fillss it before submission.";
                  error.push({
                    label: element.properties.label,
                    value:
                      element.properties.label +
                      " is a required question. Please fill it before submission.",
                  });
                } else if (element.properties.required === false) {
                  if (typeof data.value === "string") {
                    //Regular expression for validation
                    if (data.label === "Date of Birth") {
                      var date = data.value.split("-");

                      // Date of Age should be between 18-40 years

                      var daterange = data.value;

                      var today = new Date();
                      var birthDate = new Date(daterange);
                      var age = today.getFullYear() - birthDate.getFullYear();
                      var m = today.getMonth() - birthDate.getMonth();
                      if (
                        m < 0 ||
                        (m === 0 && today.getDate() < birthDate.getDate())
                      ) {
                        age--;
                      }
                      if (age <= 17) {
                        currentError = "Age should not smaller than 18 year";
                        error.push({
                          label: element.properties.label,
                          value: "Age should not smaller than 18 year",
                        });
                      } else if (age > 55) {
                        currentError = "Age should not greater than 55 year";
                        error.push({
                          label: element.properties.label,
                          value: "Age should not greater than 55 year",
                        });
                      }
                    }
                  }
                }
              }
            }
            // Validate with Browser Validity
            try {
              if (input.checkValidity() === false) {
                currentError =
                  "'" +
                  element.properties.label +
                  "' contains an invalid answer. " +
                  input.validationMessage;
                error.push({
                  label: element.properties.label,
                  value: input.validationMessage,
                });
              }
            } catch (e) {}
          }
        }
      }
      if (supplement && data !== null && JSON.stringify(data) !== "{}") {
        if (data?.valueOfField && Array.isArray(data.valueOfField)) {
          formData = [...formData, ...data.valueOfField];
        } else {
          formData.push(data);
        }
      }
    });

    let payload = new FormData();

    if (formData.length !== 0) {
      formData.forEach((ele) => {
        if (ele.element.type === "file") {
          let file = document.getElementById(ele.element.id).files[0];
          if (file) {
            let extension = file.name.split(".").pop().toLowerCase();
            let ext = [];
            for (let key in ele.element.extensions) {
              if (ele.element.extensions[key]) {
                ext.push(key);
              }
            }
            let size =
              file.size <= parseInt(ele.element.properties.size) * 1024;
            if (!size) {
              currentError = `Your ${ele.element.properties.label} must not be larger than ${ele.element.properties.size} kb`;
              error.push({
                label: ele.properties.label,
                value: `Your ${ele.properties.label} must not be larger than ${ele?.properties.size} kb`,
              });
            } else {
              if (ext.includes(extension)) {
                payload.append(ele.element.properties.label, file);
              } else {
                currentError = `The image is in an unsupported extension '${extension}'.`;
                error.push({
                  label: ele.properties.label,
                  value: `The image is in an unsupported extension '${extension}'.`,
                });
              }
            }
          } else {
            if (
              ele.element.properties.required &&
              (ele.value === "" || ele.value === undefined)
            ) {
              currentError = `You must attach your ${ele.element.properties.label}`;
              error.push({
                label: ele.element.properties.label,
                value: `You must attach your ${ele.element.properties.label}`,
              });
            }
          }
        }
      });
    }

    formData = formData?.map((key) => {
      if (key.element.type === "capturephoto") {
        if (key.file) {
          payload.append(key.label, key.file);
        }
        const { file, ...rest } = key;
        return rest;
      }
      return key;
    });

    if (currentError === "" && error.length === 0) {
      setLoad(true);
      payload.append("response", JSON.stringify(formData));
      payload.append("form", id);

      let result = {};

      try {
        if (
          formType === "long-form" ||
          candidateInformation?.responses?.length > 0
        ) {
          result = await Axios.patch(
            url(`candidate/${candidateId}`),
            payload,
            {},
          );
        } else {
          result = await Axios.put(
            url(`candidate/${candidateId}`),
            payload,
            {},
          );
        }
        setSuccess(true);
        localStorage.setItem("ids", result.data.id);
        // const candidateId = await result.data.id
        const token = localStorage.getItem("candidate.token");
        if (token) {
          history.push(`/careers/home`);
        } else {
          await getCandidateInfo("long-form");
          message.success("Details updated successfully.");
        }
      } catch (error) {
        if (error.response.data.error.name === "MongoError") {
          setError("Email is already in use. Please use another email.");
        } else if (error.response.data.error === "Mobile No already Exist") {
          setError(
            "Mobile number is already in use. Please use another mobile number.",
          );
        } else {
          setError("Email already exist!");
          console.error(error);
        }
      } finally {
        setLoad(false);
      }
    } else {
      const map = new Map();
      error.forEach((item) => {
        map.set(item.label, item);
      });
      const filtered = Array.from(map.values());
      setErrorInputs(filtered);
      setLoad(false);
    }
  }

  let designationDepartment = {};
  let stateCity = {};

  return (
    <>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="w-100">
        <div className="row mx-0 justify-content-center">
          <div className="col-md-7">
            <div className=" mt-4 p-3 bg-white rounded">
              <If test={isLoading === true}>
                <h1>Loading form...</h1>
                <Else>
                  <h1 className="candidate-form-title">{form?.name}</h1>
                  <p className="candidate-form-description">
                    {/* {form.trf.overview} */}
                  </p>
                  <hr />
                  <div className="my-3" id="candidateForm">
                    {form.elements.map((element, key) => {
                      // edit candidate of simple formdata(not bulkupload data)

                      if (
                        formType === "long-form" ||
                        candidateInformation?.responses?.length > 0
                      ) {
                        for (
                          let i = 0;
                          i < candidateInformation?.responses?.length;
                          i++
                        ) {
                          if (
                            candidateInformation.responses[i].element.id ===
                            element.id
                          ) {
                            if (element.type === "statecity") {
                              if (candidateInformation.responses[i]?.label === "Select State") {
                                stateCity.state = candidateInformation.responses[i].value;
                              }
                              if (candidateInformation.responses[i]?.label === "Select City") {
                                stateCity.city = candidateInformation.responses[i].value;
                              }
                              if (
                                candidateInformation.responses[i]?.label === "State And City" ||
                                candidateInformation.responses[i]?.label === "State and City"
                              ) {
                                const valStr = String(candidateInformation.responses[i].value || "");
                                if (valStr.includes("-")) {
                                  const parts = valStr.split("-").map((s) => s.trim());
                                  stateCity.state = stateCity.state || parts[0] || "";
                                  stateCity.city = stateCity.city || parts[1] || parts[0] || "";
                                }
                              }
                              element.value = {
                                state: stateCity?.state || (typeof candidateInformation.responses[i]?.value === "object" ? candidateInformation.responses[i]?.value?.state : candidateInformation.responses[i]?.value) || "",
                                city: stateCity?.city || (typeof candidateInformation.responses[i]?.value === "object" ? candidateInformation.responses[i]?.value?.city : "") || "",
                              };
                            }
                            if (element.type === "departmentdesignation") {
                              console.log(
                                candidateInformation.responses[i],
                                designationDepartment,
                                "KUTYFTYR",
                              );
                              if (
                                candidateInformation.responses[i]?.label ===
                                "Select Designation"
                              ) {
                                designationDepartment.designation =
                                  candidateInformation.responses[i].value;
                                designationDepartment.designationText =
                                  candidateInformation.responses[i].value;
                              }

                              if (
                                candidateInformation.responses[i]?.label ===
                                "Select Department"
                              ) {
                                designationDepartment.department =
                                  candidateInformation.responses[i].value;
                                designationDepartment.departmentText =
                                  candidateInformation.responses[i].value;
                              }
                              element.value = {
                                department:
                                  designationDepartment?.department || "",
                                departmentText:
                                  designationDepartment?.departmentText || "",
                                designation:
                                  designationDepartment?.designation || "",
                                designationText:
                                  designationDepartment?.designationText || "",
                              };
                            } else if (
                              element.type === "capturephoto" ||
                              element.type === "file"
                            ) {
                              if (element.type === "capturephoto") {
                                element.value = {
                                  name: candidateInformation.responses[i].value,
                                };
                              }
                              if (element.type === "file") {
                                element.properties.value =
                                  candidateInformation.responses[i].value;
                              }
                              const fieldName = element.properties.label;
                              if (
                                fieldName
                                  .toLowerCase()
                                  .indexOf("profile photo") === 0
                              ) {
                                const L2 =
                                  interviews.find(
                                    (ele) =>
                                      (ele.modeOfInterview === "Video Call" ||
                                        ele.modeOfInterview === "In Person") &&
                                      ele?.profileImageMatchStatus === true &&
                                      ele?.status === "Selected",
                                  ) || false;
                                let isPhotoRestrict = false;
                                if (
                                  L2 &&
                                  candidateInformation.responses[i]?.value
                                ) {
                                  isPhotoRestrict = true;
                                }
                                element.isPhotoRestrict = isPhotoRestrict;
                              }
                            } else {
                              element.properties.value =
                                candidateInformation.responses[i].value;
                            }
                          }
                        }
                      } else {
                        if (candidateInformation !== undefined || null) {
                          for (const [key, value] of Object.entries(
                            candidateInformation,
                          )) {
                            if (`${key}` === element.properties.label) {
                              element.properties.value = value;
                            }

                            if (key === "voiceBotData") {
                              if (
                                element?.properties?.label ==
                                  "Languages Known" &&
                                (
                                  value?.English_and_Hindi || ""
                                ).toLowerCase() === "yes"
                              ) {
                                element.properties.value = ["English", "Hindi"];
                              }
                              if (
                                element?.properties?.label ==
                                  "Highest Qualification" &&
                                value?.qualification_extraction
                              ) {
                                element.properties.value = courseType;
                              }
                              // Prefill DOB from voiceBotData as fallback
                              if (
                                element?.properties?.label === "Date of Birth" &&
                                !element.properties.value &&
                                value?.dob
                              ) {
                                try {
                                  const dateMatch = String(value.dob).match(/^\d{4}-\d{2}-\d{2}/);
                                  if (dateMatch) {
                                    element.properties.value = dateMatch[0];
                                  }
                                } catch (e) {
                                  console.error("Error parsing voiceBotData dob:", e);
                                }
                              }
                            }
                          }
                        }
                      }
                      if (
                        element.type === "radio" ||
                        element.type === "select"
                      ) {
                        if (element.parent.length !== 0) {
                          for (let j = 0; j < element.parent.length; j++) {
                            for (
                              let i = 0;
                              i < candidateInformation?.responses?.length;
                              i++
                            ) {
                              if (
                                candidateInformation.responses[i].element.id ===
                                element.parent[j].child.id
                              ) {
                                element.parent[j].child.properties.value =
                                  candidateInformation.responses[i].value;
                              }
                            }
                          }
                        }
                      }

                      if (hash === "#editable") {
                        if (element.properties.label !== undefined) {
                          if (
                            element.properties.label.trim() === "Name" ||
                            element.properties.label.trim() === "Email" ||
                            element.properties.label.trim() === "Date of Birth"
                          ) {
                            element.editable = true;
                          } else {
                            element.editable = false;
                          }
                        }
                      } else {
                        element.editable = true;
                      }
                      return (
                        <GetFormComponent
                          element={element}
                          errorInputs={errorInputs}
                          key={key}
                          departments={departments}
                          formError={formError}
                          tokenType="candidate.token"
                          form={candidateInformation}
                          formType={"Joining"}
                          formId={id}
                          getCandidateDetails={getCandidateInfo}
                        />
                      );
                    })}
                  </div>
                  <div className="mb-5 px-2">
                    <If test={error !== ""}>
                      <div className="alert alert-danger">{error}</div>
                    </If>
                    <button
                      className={cx("btn", "btn-primary")}
                      type="submit"
                      onClick={onClickFormSubmit}
                      // disabled={!agreed}
                    >
                      Submit
                    </button>
                  </div>
                </Else>
              </If>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateCandidateForm;
